import { useActiveItem } from '@xing-com/hub';
import { addParams } from '@xing-com/xing-tracking';

import { StyledLink } from './me-menu-styled-link';

type MeMenuItemProps = {
  color?: 'premium' | 'proJobs' | 'proBusiness';
  dataTestId?: string;
  href: string;
  title: string;
  activeItemValues?: string[];
  tracking?: Record<string, string>;
};

export const MeMenuItem: React.FC<MeMenuItemProps> = ({
  href,
  title,
  color,
  tracking,
  activeItemValues,
  dataTestId,
}) => {
  const activeItem = useActiveItem();
  const isActive = activeItem ? activeItemValues?.includes(activeItem) : false;

  const completeTrackingURL =
    href && tracking ? addParams(href, tracking) : href;

  return (
    <StyledLink
      $isActive={isActive}
      $color={color}
      data-testid={dataTestId}
      to={completeTrackingURL}
    >
      <span>{title}</span>
    </StyledLink>
  );
};
